<template>
  <div class="flex items-center">
    <slot name="dec">
      <button type="button"
        class="btn numeral-button px-0"
        :disabled="!canDecrease"
        @click="handleDec">
        <svg class="m-auto" width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H0V0H14V2Z" fill="inherit" />
        </svg>
      </button>
    </slot>

    <slot>
      <div style="width: 3.5ch" class="text-center">
        {{ value }}
      </div>
    </slot>

    <slot name="inc">
      <button type="button"
        class="btn numeral-button px-0"
        :disabled="!canIncrease"
        @click="handleInc">
        <svg class="m-auto" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="inherit"/>
        </svg>
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: false,
      default: () => 0
    },
    max: {
      type: Number,
      required: false,
      default: () => 99
    }
  },
  computed: {
    canDecrease () {
      return this.value > this.min
    },
    canIncrease () {
      return this.value < this.max
    }
  },
  methods: {
    handleDec (e) {
      e.preventDefault()
      if (this.canDecrease) {
        this.$emit('input', this.value - 1)
      }
    },
    handleInc (e) {
      e.preventDefault()
      if (this.canIncrease) {
        this.$emit('input', this.value + 1)
      }
    }
  }
}
</script>
